// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y1n8","col":"styles_col__2p0Fn"};